import { isIphoneLike } from "../is-iphone-like/isIphoneLike.constant";
/**
 * A boolean which indicates if the device could be a iPad. Potential for false positives with non iPad Apple devices which have touch screens.
 */
export const isIpadLike = navigator.userAgent.includes("iPad") || (!isIphoneLike && navigator.userAgent.includes("Mac") && window.navigator.maxTouchPoints > 2);
